Vue.asyncComponent('ak-text', {
    props: {
        label: {
            type: String,
            required: false,
        },
        text: {
            type: String,
            required: true,
        },
        muted: {
            type: Boolean,
            default: false
        },
        bold: {
            type: Boolean,
            default: false
        },
        textOnNewLine: {
            type: Boolean,
            default: false
        },
    },
}, 'layout/ak-text.html');